var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPackage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    fill: "#251163"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8195 10.2825L13.8926 13.7155C13.6539 13.8541 13.3537 13.8541 13.1074 13.7155L7.18046 10.2825C6.7571 10.0362 6.64934 9.45889 6.97263 9.09712C7.19585 8.8431 7.44987 8.63527 7.71927 8.48902L11.8912 6.17981C12.7841 5.67948 14.2312 5.67948 15.1241 6.17981L19.2961 8.48902C19.5655 8.63527 19.8195 8.8508 20.0428 9.09712C20.3507 9.45889 20.2429 10.0362 19.8195 10.2825Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0611 15.1472V20.3968C13.0611 20.9818 12.4684 21.3667 11.945 21.1127C10.3593 20.3352 7.68831 18.8804 7.68831 18.8804C6.74923 18.3493 5.97949 17.01 5.97949 15.9093V11.9374C5.97949 11.3293 6.61837 10.9445 7.14179 11.2447L12.6762 14.4545C12.9071 14.6007 13.0611 14.8624 13.0611 15.1472Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.939 15.1472V20.3968C13.939 20.9818 14.5317 21.3667 15.0551 21.1127C16.6407 20.3352 19.3117 18.8804 19.3117 18.8804C20.2508 18.3493 21.0205 17.01 21.0205 15.9093V11.9374C21.0205 11.3293 20.3817 10.9445 19.8582 11.2447L14.3238 14.4545C14.0929 14.6007 13.939 14.8624 13.939 15.1472Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/package.8455e3c593ea1d4799a0132a2a050d70.svg";
export { ForwardRef as ReactComponent };